import React from "react";
import { HStack } from "native-base";
import ContentContainer from "atoms/ContentContainer";
import { useTranslation } from "react-i18next";
import SDScheduleBox from "atoms/SDScheduleBox";
import SDRequestBox from "atoms/SDRequestBox";
import SDRequestsList from "organisms/SDRequestsList";

const SalaryDisbursement = () => {
  const { t } = useTranslation("common");
  return (
    <ContentContainer title={t("salaryDisbursement.title")} flex={[1, 1, 1, 0.85, 0.85]}>
      <HStack space={2} w="100%" mt="24px">
        <SDScheduleBox />
        <SDRequestBox />
      </HStack>
      <SDRequestsList />
    </ContentContainer>
  );
};

export default SalaryDisbursement;
